export const SUPPORTED_LOCALES = ['en', 'sv'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];
export const DEFAULT_LOCALE: SupportedLocale = 'sv';
